import React, { useEffect, useState } from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";

import { setModoTela } from "../geracaoLeituraActions";
import ContentCard from "../../common/template/contentCard.jsx";
import ContentCardBody from "../../common/template/contentCardBody.jsx";
import Grid from "../../common/layout/grid.jsx";
import Button from "../../common/button/button.jsx";
import { RowFlex } from "../../common/layout/RowFlex.jsx";
import DateFormat from "../../common/dateFormat/DateFormat.js";
import { StatusLeituraWifi } from "./StatusLeituraWifi.jsx";
import { SaldosUnidadeConsumidoraMobile } from "./SaldosUnidadeConsumidoraMobile.jsx";

function GeracaoLeituraCardMobileComponent(props) {
    const bgButton = "linear-gradient(225deg, rgb(255 255 255) 0%, rgb(145 234 255) 100%)";
    const color = props.color || "#222";
    const buttonColor = props.buttonColor || "#222";
    
    return (
        <ContentCard style={{ background: "#023b49", color, paddingLeft: 0 }}>
            <ContentCardBody padding="10px" style={{ minHeight: "90vh" }}>
                <RowFlex style={{ justifyContent: "flex-end", padding: "0 !important" }}>
                    <Grid cols="12 12 12 12">
                        <Button style={{ margin: "5px 0px" }} text="Voltar" type={"warning"} icon={"fa fa-chevron-left"} event={() => props.setModoTela("lista", {})} />
                    </Grid>
                </RowFlex>
                <RowFlex style={{ justifyContent: "flex-end", padding: "0 !important", color }}>
                    <Grid cols="12 12 12 12" style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
                        <b style={{ paddingLeft: 10 }}>Unidade Consumidora</b>
                        {props.registro.nome_unidade_consumidora}
                    </Grid>
                    <Grid cols="12 12 12 12" style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
                        <StatusLeituraWifi style={{ display: "flex", gap: 20, alignItems: "center" }} item={props.registro} />
                    </Grid>
                    <Grid cols="12 12 12 12" style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
                        <SaldosUnidadeConsumidoraMobile
                            sideTableButton={true}
                            borderColor={color}
                            setModoTela={props.setModoTela}
                            item={props.registro}
                            getDadosItem={props.getDadosItem}
                            buttonHeight={75}
                            buttonWidth={"80vw"}
                            buttonBackground={bgButton}
                            buttonBorderRadius={"0.6rem"}
                        />
                    </Grid>
                    <Grid cols="12 12 12 12" style={{ display: "flex", justifyContent: "center", gap: "10px", flexWrap: "wrap", marginLeft: -6 }}
                    >
                        <div style={{ width: "45%", display: "flex", justifyContent: "center" }}>
                            <Button
                                title={"Ver Economia"}
                                style={{
                                    width: "100%",
                                    height: 50,
                                    padding: 0,
                                    background: "linear-gradient(225deg, rgb(255 255 255) 0%, rgb(145 234 255) 100%)",
                                    borderRadius: "0.6rem",
                                }}
                               text={
                                    <div style={{ alignItems: "center", marginTop: -4 }}>
                                        <i className="fas fa-search-dollar" style={{ fontSize: "1.2rem", padding: 10 }} />
                                        <span style={{ fontSize: "0.8rem", color: "#000", textAlign: "center" }}>
                                            Ver Economia
                                        </span>
                                    </div>
                                }
                                type={"info"}
                                event={() => {
                                    props.setModoTela("graficoEconomia", props.registro);
                                }}
                            />
                        </div>

                        <div style={{ width: "45%", display: "flex", justifyContent: "center" }}>
                            <Button
                                title={"Retorno do Investimento"}
                                style={{
                                    width: "100%",
                                    height: 50,
                                    padding: 0,
                                    background: "linear-gradient(225deg, rgb(255 255 255) 0%, rgb(145 234 255) 100%)",
                                    borderRadius: "0.6rem",
                                }}
                                text={
                                    <div style={{ display: "flex", justifyContent: "center" }}>
                                        <i className="fas fa-chart-line" style={{ fontSize: "1.2rem", padding: 10 }} />
                                        <div style={{ fontSize: "0.8rem", color: "#000" }}>
                                            <div>Ver Retorno do</div>
                                            <div>Investimento</div>
                                        </div>
                                    </div>
                                }
                                type={"info"}
                                event={() => {
                                    props.setModoTela("graficoRetornoFinanceiro", props.registro);
                                }}
                            />
                        </div>
                    </Grid>
                    <Grid cols="12 12 12 12" style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
                        <div>
                            <Button
                                style={{ margin: "5px 0px", padding: 0, height: 40, width: "83vw", lineHeight: "0.8rem", backgroundColor: "rgb(39, 163, 67)", borderRadius: "0.6rem", color: "#fff" }}
                                type="info"
                                title="Balanço Energético"
                                text={
                                    <div>
                                        <div style={{ fontSize: "0.8rem", marginBlock: 2 }}>
                                            <i className="fas fa-balance-scale mr-2"></i>
                                            <span className="mr-2">Balanço</span>
                                        </div>
                                        <div style={{ fontSize: "0.8rem" }}>
                                            <i className="fas fa-bolt ml-2 mr-1"></i> Energético
                                        </div>
                                    </div>
                                }
                                event={() => props.exibirBalancoEnergetico(props.registro)}
                            />
                        </div>
                    </Grid>
                    <div
                        style={{
                            display: "flex",
                            justifyContent: "center",
                            flexWrap: "wrap",
                            alignItems: "center",
                            marginTop: 10,
                            width: "88%",
                            maxWidth: "360px",
                            margin: "10px auto",
                            backgroundColor: "transparent",
                            border: "1px solid rgba(255, 255, 255, 0.70)",
                            borderRadius: "14px",
                            backdropFilter: "blur(2px)",
                        }}
                    >
                    <Grid cols="12 12 12 12" style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
                        <b style={{ textAlign: "center", color, marginBlock: 10 }}>Potência Instalada</b>
                    </Grid>
                    <Grid cols="6 6 6 6" style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
                        <Button
                            title={"Visualizar módulos"}
                            style={{
                                width: "100%",
                                height: 100,
                                padding: 0,
                                margin: 10,
                                background: "linear-gradient(135deg, #f5f5f5 0%, #d0d0d0 50%, #b5b5b5 100%)",
                                borderRadius: "0.6rem",
                            }}
                            text={
                                <div>
                                    <b style={{ textAlign: "center", color: buttonColor, marginBlock: 10 }}>Módulos</b>
                                    <p style={{ marginTop: 0, marginBottom: 0 }}>
                                        <i className="fas fa-solar-panel" style={{ fontSize: "1.1rem", padding: 10 }}></i>
                                    </p>
                                    <p style={{ marginBottom: 0 }}>
                                        {props.registro.modulos_potencia_total && parseFloat(props.registro.modulos_potencia_total) >= 0
                                            ? parseFloat(props.registro.modulos_potencia_total).toFixed(1).replace(".", ",") + " kW"
                                            : "-"}
                                    </p>
                                    <p style={{ fontSize: "0.7rem", margin: 0, color: "#222" }}>Detalhar</p>
                                </div>
                            }
                            type={"info"}
                            event={() => {
                                props.getModulos(props.registro.id_unidade_consumidora);
                                props.setModoTela("modulos", props.registro);
                            }}
                        />
                    </Grid>
                    <Grid cols="6 6 6 6" style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
                        <Button
                            title={"Visualizar dispositivos"}
                            style={{
                                width: "100%",
                                height: 100,
                                padding: 0,
                                margin: 0,
                                background: "linear-gradient(135deg, #f5f5f5 0%, #d0d0d0 50%, #b5b5b5 100%)",
                                borderRadius: "0.6rem",
                            }}
                            text={
                                <div>
                                    <b style={{ textAlign: "center", color: buttonColor, marginBlock: 10 }}>Inversores</b>
                                    <p style={{ marginTop: 5, marginBottom: 8 }}>
                                        <i
                                            style={{
                                                fontSize: "1.1rem",
                                                verticalAlign: "middle",
                                            }}
                                            className="fas fa-charging-station"
                                        />
                                    </p>
                                    <p style={{ marginBottom: 0 }}>
                                        {props.registro.inversor_potencia_total && parseFloat(props.registro.inversor_potencia_total) >= 0
                                            ? parseFloat(props.registro.inversor_potencia_total).toFixed(1).replace(".", ",") + " kW"
                                            : "-"}
                                    </p>
                                    <p style={{ fontSize: "0.7rem", margin: 0, color: "#222" }}>Detalhar</p>
                                </div>
                            }
                            type={"info"}
                            event={() => {
                                props.setModoTela("dispositivos", props.registro);
                            }}
                        />
                    </Grid>
                    </div>

                    <Grid cols="12 12 12 12" style={{ maxWidth: 342, margin: "0 auto", width: "100%",}}>
                        <Button
                            style={{ margin: "5px 0px", backgroundColor: "rgb(102 109 103)", borderRadius: "0.6rem", color: "#fff" }}
                            disabled={!props.usuarioLogado.acesso_manutencao_solar_visualizar}
                            title={`Exibir informação de manutenções`}
                            text={"Log de Manutenção"}
                            icon={`fas fa-cogs`}
                            type={"info"}
                            event={() => props.exibirManutencoes(props.registro)}
                        />
                        <div style={{ height: 40, paddingBlock: 5, textAlign: "center", color }}>
                            {props.registro.manutencoes && props.registro.manutencoes.find((l) => l.id_manutencao_tipo == 1) ? (
                                <p style={{ fontSize: "0.7rem", lineHeight: "0.8rem", margin: 0 }}>
                                    <div> Última limpeza:</div>
                                    {DateFormat.formatarDataSqlParaTela(props.registro.manutencoes.find((l) => l.id_manutencao_tipo == 1).datahora)}
                                </p>
                            ) : (
                                <p style={{ fontSize: "0.7rem", lineHeight: "0.8rem", margin: 0 }}>Nenhuma limpeza realizada</p>
                            )}
                        </div>
                    </Grid>
                </RowFlex>
            </ContentCardBody>
        </ContentCard>
    );
}

const mapStateToProps = (state) => {
    return {
        modoTela: state.geracaoLeitura.modoTela,
        filtro: state.geracaoLeitura.filtro,
        registro: state.geracaoLeitura.registro,
        usuarioLogado: state.auth.usuarioLogado,
        STATUS_COR_AMARELA: state.geracaoLeitura.AMARELA,
        STATUS_COR_VERMELHA: state.geracaoLeitura.VERMELHA,
        STATUS_COR_VERDE: state.geracaoLeitura.VERDE,
    };
};
const mapDispatchToProps = (dispatch) => bindActionCreators({ setModoTela }, dispatch);
export const GeracaoLeituraCardMobile = connect(mapStateToProps, mapDispatchToProps)(GeracaoLeituraCardMobileComponent);
